<template>
  <div class="user-preview__list card">
    <div class="search-users__item" v-for="(user, index) in users" :key="user.userId">
      <div class="user-preview">
        <router-link :to="{ name: 'UserProfile', params: { link: user.link } }" class="user-preview__link" target="_blank">
          <el-avatar class="user-preview__avatar" :size="50">
            <user-avatar :userId="user.userId" :alt="user.firstName + ' ' + user.lastName"/>
          </el-avatar>
          <div class="user-preview__info">
            <div class="user-preview__name">
              {{ user.firstName }} {{ user.lastName }}
            </div>
            <div class="user-preview__description">
              {{ user.city }},{{ user.country }}
            </div>
          </div>
        </router-link>
      </div>
      <el-divider v-if="showDividers && index < users.length - 1" />
    </div>
    <div class="user-preview__empty-text" v-if="total != null && users.length === 0">
      <slot name="empty">There are no users matching your search query</slot>
    </div>
  </div>
</template>

<script>
import UserAvatar from '../profile/UserAvatar.vue';

export default {
  name: 'UserPreviewList',
  components: { UserAvatar },
  props: {
    users: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: null,
    },
    showDividers: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.user-preview {
    $this: &;

    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    &__link {
        display: flex;
        flex-flow: row nowrap;
        flex-grow: 1;

        &:hover {
            #{$this}__name {
                color: var(--color-primary-400);
            }
        }
    }

    &__avatar {
        margin-right: var(--global-dimension-size-125);
    }

    &__name {
        font-weight: var(--global-font-weight-medium);
    }

    &__role {
        margin-left: var(--global-dimension-size-125);
    }

    &__description {
        margin-bottom: var(--global-dimension-size-65);
        font-size: var(--font-size-200);
    }

    &__participants-icon {
        margin-right: var(--global-dimension-size-65);
    }

    &__participants {
        font-size: var(--font-size-200);
    }
}

.user-preview__list {
    // Add any desired styles for the list container here
}
</style>